import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import {
  authorizingSelector,
  isImpersonationSessionSelector,
  isLoggedInSelector,
  selectUser,
} from "src/store/system/selector";
import { supportIsLoggedIn } from "src/store/support/selector";
import type { ProspectSession } from "src/utils/meta";

/** The session details `isProspect` / `metaPixelWanted` decide on. */
export default function useProspectSession(): ProspectSession {
  const { pathname } = useLocation();
  const authorizing = useSelector(authorizingSelector);
  const loggedIn = useSelector(isLoggedInSelector);
  const user = useSelector(selectUser);
  const impersonating = useSelector(isImpersonationSessionSelector);
  const supportLoggedIn = useSelector(supportIsLoggedIn);

  return {
    pathname,
    authorizing,
    loggedIn,
    user,
    impersonating,
    supportLoggedIn,
  };
}
